<template>
    <div>
        
        <div class="row">
            <div class="sm-12">
                <hr />
            </div>
            <div class="sm-6 md-6">
                <p>
                    <strong>Condomínio: </strong>
                    {{ condominio.nome }}
                </p>
            </div>
            <div class="sm-6 md-6">
                <p>
                    <strong>Abreviação: </strong>
                    {{ condominio.abrev }}
                </p>
            </div>
            <div class="sm-12">
                <hr style="margin-top: 0.25em" />
            </div>
        </div>
        <div class="row">
            <div class="sm-12">
                <p>
                    <strong>Endereço: </strong>
                    {{ condominio.endereco.enderecoCompleto }}
                </p>
                <hr />
            </div>
        </div>
        <div class="row">
            <div class="sm-12">
                <p>
                    <strong>
                        MEMO JURÍDICO DE {{ data_de | date('dd/LL/yyyy') }} À {{ data_ate | date('dd/LL/yyyy') }}
                    </strong>
                </p>
            </div>
            <div class="sm-12">
                <hr />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['data_de','data_ate'],
    computed: {
        condominio() {
            return this.$store.getters.condominio;
        }
    }
}
</script>